import React, { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isCustomer } from "./common/authentification-functions";
import { ApplicationRoutes } from "../routes";

type Props = {};

const CustomerGuard: React.FC<Props> = memo((props: Props) => {
	if (!isCustomer()) {
		return <Navigate to={`/${ApplicationRoutes.CUSTOMER_SIGNIN}`} replace />;
	}

	return <Outlet />;
});

export default CustomerGuard;
